import PerdasPisoteioSBACS from "./PerdasPisoteio-SBA-CS";
// import PlantioSBACS from "./Plantio-SBA-CS copy";
import CSVGeral from "./CSVGeral";
import JSONPlantio from "./JSONPlantio";

const typeExposts = [CSVGeral, JSONPlantio, PerdasPisoteioSBACS/*, PlantioSBACS*/];

export default typeExposts;
